(function () {
  class CategoryImageButtonsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    init() {
      if (typeof window.Swiper === 'undefined' || this.swiper) return;

      const sliderEl = this.querySelector('.category-image-buttons-slider__slider');
      if (!sliderEl) return;

      const prevEl = sliderEl.querySelector('.swiper-button-prev');
      const nextEl = sliderEl.querySelector('.swiper-button-next');
      const slidesMobile = parseFloat(this.dataset.slidesMobile || '3.5');
      const slidesDesktop = parseFloat(this.dataset.slidesDesktop || '8');
      const slideGapMobile = parseInt(this.dataset.slideGapMobile || '15', 10);
      const slideGapDesktop = parseInt(this.dataset.slideGapDesktop || '15', 10);
      const speed = parseInt(this.dataset.speed || '450', 10);
      const smooth = this.dataset.smooth === 'true';
      const loop = this.dataset.loop === 'true';
      const showArrows = this.dataset.showArrows === 'true';

      const config = {
        slidesPerView: slidesMobile,
        spaceBetween: slideGapMobile,
        speed: speed,
        loop: loop,
        grabCursor: true,
        watchOverflow: true,
        centerInsufficientSlides: true,
        breakpoints: {
          750: {
            slidesPerView: slidesDesktop,
            spaceBetween: slideGapDesktop
          }
        },
        navigation: showArrows && prevEl && nextEl ? { prevEl: prevEl, nextEl: nextEl } : false
      };

      if (smooth) {
        config.freeMode = {
          enabled: true,
          momentum: true,
          sticky: false
        };
      }

      this.swiper = new window.Swiper(sliderEl, config);
    }

    connectedCallback() {
      if (typeof window.Swiper !== 'undefined') {
        this.init();
        return;
      }

      const onLoad = () => {
        window.removeEventListener('load', onLoad);
        this.init();
      };
      window.addEventListener('load', onLoad);
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('category-image-buttons-slider')) {
    customElements.define('category-image-buttons-slider', CategoryImageButtonsSlider);
  }
})();
